import { getStorage } from '../platform'
import { resetSharedStore } from '../storeRef'
import { decrypt, encrypt } from './encryption'

class Auth {
  static isLoggedIn() {
    return !!getStorage().getToken() && !!getStorage().getUsername()
  }

  static hasToken() {
    return !!getStorage().getToken()
  }

  static saveUserDetails(userPayload: any) {
    const { token, user } = userPayload
    getStorage().setUsername(user.username)
    getStorage().setToken(encrypt(token))
  }

  static fetchToken() {
    const token = getStorage().getToken()
    return token ? decrypt(token) : null
  }

  static fetchUsername() {
    return getStorage().getUsername()
  }

  static updateUsername(username: any) {
    getStorage().setUsername(username)
  }

  static logUserOut() {
    getStorage().clear()
    resetSharedStore()
  }
}

export default Auth
